import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';

import styles from './FileLink.scss';

class FileLink extends Component {

    constructor(...args) {
        super(...args);
        this.onDesktopClick = this.onDesktopClick.bind(this);
        this.onMobileClick = this.onMobileClick.bind(this);
    }

    isMobileButtonVisible() {
        const { mobileButtonSection } = this;
        if (lodash.isNil(mobileButtonSection)) {
            return false;
        }
        return mobileButtonSection.offsetHeight > 0;
    }

    onDesktopClick(e) {
        if (this.isMobileButtonVisible()) {
            return;
        }
        const { onClick } = this.props;
        onClick();
    }

    onMobileClick(e) {
        if (!this.isMobileButtonVisible()) {
            return;
        }
        const { onClick } = this.props;
        onClick();
    }

    render() {
        const { document } = this.props;
        if (lodash.isNil(document)) {
            return null;
        }
        const { name } = document;
        return (
            <article className={styles.file} onClick={this.onDesktopClick} data-cy="FileLink">
                <section className={styles.headerSection}>
                    <div className={styles.icon}/>
                    <header className={styles.header} data-cy="FileLink-name">
                        {name}
                    </header>
                </section>
            </article>
        );
    }
}

FileLink.propTypes = {
    document: PropTypes.shape({
        name: PropTypes.string,
    }),
    onClick: PropTypes.func
};

export default FileLink;
